<template>
  <!-- 列表布局 -->
  <div class="lists">
    <div class="inner-box wow" :class="{'fadeInUp':windowSol==0}">
      <div
        @click="goto(val.id)"
        class="sec"
        v-for="(val, index) in lists"
        :key="index"
        :class="{ special: (index + 1) % 3 == 0 }"
      >
        <!-- :class="{ special: (index + 1) % 3 == 0 }" -->

        <div class="top">
          <img class="img" :src="val.defineUrl" v-if="val.defineUrl" alt="" />
        </div>
        <p class="title">{{ val.title }}</p>
        <div class="bottom">
          <p class="detail">
            {{ val.data.explain | ellipsis }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { listNextWithFilter } from "../api/index";
import { WOW } from "wowjs";
import local from "../utils/local";
// import func from "vue-editor-bridge";
export default {
  name: "lists",
  props: ["categoryId", "size","prePath"],
  data() {
    return {
      lists: [],
      pageSize: 30,
      windowSol:0
    };
  },
  methods: {
    async getLists(id) {
      let send = {
        url: {
          page: 1,
          size: this.pageSize,
        },
        data: {
          categoryIdList: [id],
          needData: true,
          orderType: "DESC",
        },
      };
      let res = await listNextWithFilter(send);
      if (res.type == "success") {
        let lists = res.data;

        lists.map((val) => {
          this.$set(val, "defineUrl", this.$srcHandle(val.data.imageclipper));
        });

        //排序
        lists.sort((a, b) => {
          return a.data.number - b.data.number;//升序
          // return  b.data.number-a.data.number ;//降序
        });
      
        this.lists = lists;
        new WOW().init();
      } else {
        console.log(res.msg);
      }
      return res.data;
    },

    goto(id) {
      if(this.$route.name == "home"){
        this.windowSol = document.documentElement.scrollTop || document.body.scrollTop
        local.set("sol",this.windowSol)
      }
      local.set("prePath",this.prePath)
      this.$router.push("/detail/"+this.prePath+"/" + id);
    },
  },
  mounted() {
    this.windowSol = local.get("sol")
    this.pageSize = this.size ? this.size : this.pageSize;
    this.$nextTick(function() {
      this.getLists(this.categoryId);
    })
  },
};
</script>

<style scoped lang="less">
[v-cloak] {
	display:none !important;
}
.lists {
  .inner-box {
    .sec {
      // width: 32%;
      display: inline-block;
      vertical-align: middle;
      cursor: pointer;
      // margin-right: 1%;
      text-decoration: none;
      color: #000;
      margin-bottom: 20px;
      position: relative;
      transition: all 0.3s ease;
      &:hover {
        box-shadow: 0 0 16px #0e6cb6;
        .img {
          transform: scale(1.2);
        }
      }
      .top {
        width: 100%;
        overflow: hidden;
        img {
          transition: all 0.5s ease;
          width: 100%;
          height: 100%;
        }
      }
      .title {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 100%;
        text-align: center;
        color: #ffffff;
        opacity: 0.9;
        position: absolute;
        background-image: linear-gradient(transparent 20%, #000000 80%);
      }
      .bottom {
        background-color: #ffffff;
        margin-top: -3px;
        color: #666666;
        // 超出三行显示省略
        .detail {
          white-space: pre-line;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 4;
        }
      }
    }
    .special {
      margin-right: 0;
    }
  }
}

@media screen and (min-width: 1200px) {
  .inner-box{
    width: 100%;
    padding: 0 26px;
  }
  .sec {
    width: 32%;
    margin-right: 1%!important;
    .top {
      height: 13.5rem;
    }
  }
  .title {
    font-size: 28px;
    top: 9.125rem;
    height: 70px;
    line-height: 70px;
  }
  .bottom {
    padding: 14px 26px;
    height: 7.25rem;
    font-size: 16px;
    line-height: 30px;
    letter-spacing: 2px;
  }
}


@media screen and (min-width: 768px) and (max-width: 1200px) {
  //ipad pro
  .sec {
    width: 46%;
    margin-right: 3%!important;
    .top {
      height: 16vw;
    }
  }
  .title {
    font-size: 24px;
    top: 10vw;
    height: 6vw;
    line-height: 6vw;
  }
  .bottom {
    padding: 16px 30px;
    height: 5.875rem;
    font-size: 16px;
    line-height: 26px;
    letter-spacing: 2px;
  }
}
@media screen and (min-width: 414px) and (max-width: 768px) {
  //ipad
  .sec {
    width: 100%;
    margin-bottom: 30px !important;
    .top {
      height: 36vw;
    }
    .title {
      font-size: 24px;
      top: 26vw;
      height: 10vw;
      line-height: 10vw;
    }
    .bottom {
      padding: 16px 30px;
      height: 78px;
      font-size: 16px;
      line-height: 26px;
      letter-spacing: 2px;
    }
  }
}
@media screen and (max-width: 414px) {
  //phone
  .sec {
    width: 100%;
    margin-bottom: 30px !important;
    .top {
      height: 36vw;
    }
    .title {
      font-size: 18px;
      top: 24vw;
      height: 12vw;
      line-height: 12vw;
    }
    .bottom {
      padding: 14px 20px;
      height: 7.375rem;
      font-size: 14px;
      line-height: 22px;
      letter-spacing: 1px;
    }
  }
}
</style>
